import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
import { testimonials } from '../../data/testimonials';
const proofPoints = ['30-day free trial, no card required', 'Connects to Xero, QuickBooks and Sage', 'Credit checking, chasing and finance in one place'];
const easeOut = [0.23, 1, 0.32, 1] as const;
export function SignupAside() {
  const prefersReducedMotion = useReducedMotion();
  const [index, setIndex] = useState(0);
  const [isPaused, setIsPaused] = useState(false);
  useEffect(() => {
    if (isPaused) return;
    const timer = window.setInterval(() => {
      setIndex(current => (current + 1) % testimonials.length);
    }, 6500);
    return () => window.clearInterval(timer);
  }, [isPaused]);
  const active = testimonials[index];
  return <aside className="navy-texture hidden text-white lg:block" data-id="element-282" data-mp="3uu96ajkeiezf">
      <div className="sticky top-0 flex min-h-screen flex-col justify-between px-10 py-12 xl:px-14" data-id="element-283" data-mp="2n2d1mqr7p61">
        <p className="text-xs font-bold uppercase tracking-[0.16em] text-[#4BE4FF]" data-id="element-284" data-mp="3anmjaqkfvbj4">
          Why businesses switch
        </p>

        <div className="py-10" onMouseEnter={() => setIsPaused(true)} onMouseLeave={() => setIsPaused(false)} onFocus={() => setIsPaused(true)} onBlur={() => setIsPaused(false)} data-id="element-285" data-mp="35rxi6isrtmkp">
          <div aria-live="polite" className="relative min-h-[25rem] xl:min-h-[22rem]" data-id="element-286" data-mp="2rxwssfnplbx0">
            <AnimatePresence mode="wait" initial={false} data-id="element-287" data-mp="2n0o7w7b6ets2">
              <motion.figure key={active.id} initial={prefersReducedMotion ? {
              opacity: 0
            } : {
              opacity: 0,
              y: 14
            }} animate={{
              opacity: 1,
              y: 0
            }} exit={prefersReducedMotion ? {
              opacity: 0
            } : {
              opacity: 0,
              y: -14
            }} transition={{
              duration: 0.28,
              ease: easeOut
            }} className="absolute inset-x-0 top-0" data-id="element-288" data-mp="31nzj283g4brn">
                <div className="flex gap-1" role="img" aria-label="Rated 5 out of 5" data-id="element-289" data-mp="2xxt7yfu5hg07">
                  {[0, 1, 2, 3, 4].map(star => <StarIcon key={star} size={17} className="fill-[#4BE4FF] text-[#4BE4FF]" aria-hidden="true" data-id="element-290" data-mp="37n2wxmtp6ik3" />)}
                </div>
                <blockquote className="mt-5 text-2xl font-bold leading-[1.35] tracking-[-0.02em] xl:text-[1.7rem]" data-id="element-291" data-mp="2jz35ekokao4g">
                  {active.quote}
                </blockquote>
                <figcaption className="mt-7 border-t border-[#A6B6F8]/30 pt-5" data-id="element-292" data-mp="2ovjw9mn5bgl8">
                  <p className="text-sm font-bold" data-id="element-293" data-mp="3vdql7inx7kst">{active.name}</p>
                  <p className="mt-0.5 text-sm text-[#A6B6F8]" data-id="element-294" data-mp="46meypzlo2lg">{active.role}</p>
                </figcaption>
              </motion.figure>
            </AnimatePresence>
          </div>

          <div className="mt-6 flex gap-2" data-id="element-295" data-mp="1jq3k8p1wbzmg">
            {testimonials.map((testimonial, itemIndex) => <button key={testimonial.id} type="button" onClick={() => setIndex(itemIndex)} aria-label={`Show testimonial from ${testimonial.name}`} aria-current={itemIndex === index} className="group h-4 w-8 outline-none focus-visible:ring-2 focus-visible:ring-[#4BE4FF]" data-id="element-296" data-mp="1ez4y38u887ba" data-mpi={itemIndex}>
                <motion.span className="block h-[3px] w-full rounded-full" animate={{
              backgroundColor: itemIndex === index ? '#4BE4FF' : 'rgba(166, 182, 248, 0.35)'
            }} transition={{
              duration: 0.24,
              ease: easeOut
            }} data-id="element-297" data-mp="w0iyjyecyo9h" />
              </button>)}
          </div>
        </div>

        <ul className="space-y-3" data-id="element-298" data-mp="2tellvtv1yy4w">
          {proofPoints.map(point => <li key={point} className="flex gap-3 text-sm text-[#A6B6F8]" data-id="element-299" data-mp="2yf9egjyxjn18">
              <span aria-hidden="true" className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-[#4BE4FF]" data-id="element-300" data-mp="2jhh03v54d4om" />
              {point}
            </li>)}
        </ul>
      </div>
    </aside>;
}